
<header class="row page-header">    

    <div *ngIf="!navigatedFromPropertyList" class="col-sm-12">
        <sp-breadcrumbs>
            <sp-breadcrumb [text]="'Portfolios'" [routerLink]="['/useraccount/admin/portfolios/']"></sp-breadcrumb>
            <sp-breadcrumb [text]="portfolioBreadCrumbText"
                [routerLink]="['/useraccount/admin/portfolios/', workspaceId]"></sp-breadcrumb>
        </sp-breadcrumbs>
    
        <div class="row">
            <div class="col-sm-10">
                <a class="btn-back" [routerLink]="['/useraccount/admin/portfolios/', workspaceId]" [queryParams]="{ tabIndex: '1' }"></a>
                <div class="titles-container">
                    <div class="title">
                        {{(property$ | async)?.name}}
                    </div>                    
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="navigatedFromPropertyList" class="col-sm-12">
        <sp-breadcrumbs>
            <sp-breadcrumb [text]="'Properties'" [routerLink]="['/useraccount/admin/properties/']"></sp-breadcrumb>            
        </sp-breadcrumbs>
    
        <div class="row">
            <div class="col-sm-10">
                <a class="btn-back" [routerLink]="['/useraccount/admin/properties/']"></a>
                <div class="titles-container">
                    <div class="title">
                        {{(property$ | async)?.name}}
                    </div>                    
                </div>
            </div>
        </div>
    </div>

    <div class="col-md-6 comm-state">
        <sp-comm-state [successMessage]="'Property Saved Successfully'" [failedMessage]="'Property Save failed'"
                       [scrollOnStateChange]="true" [scrollItemSelector] = "'body'">
        </sp-comm-state>
        <sp-comm-state [successMessage]="'Property Image Saved Successfully'" [failedMessage]="'Property Image Save Failed'" #saveImage></sp-comm-state>
    </div>
</header>

<main class="admin-portfolio-edit-property">
    <div class="top">
        <nav>
            <div class="nav nav-tabs" role="tablist">
                <a *ngFor="let tab of tabs"
                  [attr.aria-controls]="tab.name"
                  [attr.aria-selected]="tab.isActive"
                  [id]="tab.name"
                  role="tab"
                  data-bs-toggle="tab"
                  class="nav-item nav-link"
                  [ngClass]="{'active': tab.isActive}"
                  (click)="onTabClick(tab)">{{ tab.name === tabReserveStudyHistory ? ((('Reserve Study' | terminology | async) || 'Reserve Study') + ' History') : tab.title }}</a>
            </div>
        </nav>
    </div>
    <div class="tab-content">
      <div role="tabpanel" aria-labelledby="General" class="tab-pane fade" [ngClass]="{'show active': currentTab?.name === tabGeneral}" [id]="tabGeneral">
        <sp-property-details-edit
            *ngIf="((property$ | async) && (propertyTypes$ | async))"
            [property]="property$ | async"
            [propertyTypes]="propertyTypes$ | async"
            [userProfile]="userProfile$ | async"
            [saveError]="adminPropertySaveError$ | async"
            (cancel)="onCancelProperty()"
            (save)="onSaveProperty($event)"
            (saveImage)="onSavePropertyImage($event)"
            (removeImage)="onRemovePropertyImage($event)"
        ></sp-property-details-edit>
      </div>
      <div role="tabpanel" aria-labelledby="Users" class="tab-pane fade" [ngClass]="{'show active': currentTab?.name === tabUsers}" [id]="tabUsers">
        <sp-workspace-users-list-display
            #adminEditPortfolioUsers          
            [workspaceUsers]="workspaceUsers"
            [workspaceProperties]="workspaceProperties"   
            [property]="property$ | async"       
            [roles]="roles$ | async"
            (updateRole)="onUpdateRole($event)"
            (invite)="onInviteUser($event)"
            (deactivate)="onDeactivateUser($event)"
            (reactivate)="onReactivateUser($event)"
            (edit)="onEditUser($event)"
        ></sp-workspace-users-list-display>
      </div>
      <div role="tabpanel" aria-labelledby="Connected Apps" class="tab-pane fade" [ngClass]="{'show active': currentTab?.name === tabConnectedApps}" [id]="tabConnectedApps">
        <sp-admin-connected-app-details
            *ngIf="property$ | async"
            [property]="property$ | async"
            [integrationProperty]="integrationProperty$ | async">
        </sp-admin-connected-app-details>
      </div>
      <div role="tabpanel" [attr.aria-labelledby]="(('Reserve Study' | terminology | async) || 'Reserve Study') + ' History'" class="tab-pane fade" [ngClass]="{'show active': currentTab?.name === tabReserveStudyHistory}" [id]="tabReserveStudyHistory">
        <sp-reserve-study-edit
            *ngIf="property$ | async"
            [property]="property$ | async"
            [reserveStudies]="reserveStudies$ | async"
            (add)="onAddReserveStudy($event)"
            (update)="onUpdateReserveStudy($event)"
            (delete)="onDeleteReserveStudy($event)"
        ></sp-reserve-study-edit>
      </div>
    </div>
</main>
